function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

import font from "./svgFont";
export var baseLabel = _extends({}, font.small, font.bold, font.middle, {
  pointerEvents: "none"
});
export var labelTiny = _extends({}, font.tiny, font.bold, font.middle, {
  pointerEvents: "none"
});
export var baseTickLabel = _extends({}, font.small, font.light, font.middle, {
  pointerEvents: "none"
});
export var tickLabels = {
  top: _extends({}, baseTickLabel, {
    dy: "-0.25em"
  }),
  right: _extends({}, baseTickLabel, font.start, {
    dx: "0.25em",
    dy: "0.25em"
  }),
  bottom: _extends({}, baseTickLabel, {
    dy: "0.25em"
  }),
  left: _extends({}, baseTickLabel, font.end, {
    dx: "-0.25em",
    dy: "0.25em"
  })
};
export default {
  baseLabel: baseLabel,
  baseTickLabel: baseTickLabel,
  tickLabels: tickLabels
};